import React from "react"

import FooterMainWhite from "../../footer-white-mode/footer-main-white"
import HeaderNavWhite from "../../header-light/header-main-white"
import Seo from "../../seo"
import ZendeskButton from "../../zendesk"

import "./index.scss"
const LayoutLight = ({ children }) => {
  return (
    <div id="LayoutLight" className=" LayoutLight">
      <div className="container ">
        <Seo />
        <HeaderNavWhite />
        {children}
        <FooterMainWhite />
      </div>
      <ZendeskButton />
    </div>
  )
}

export default LayoutLight
